import styled from "@emotion/styled";

export const Description = styled("p")`
  font-size: 14px;
  margin: 0 10px 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;
